import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';

const ImageCarousel = ({ images, title, onError }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState({});
  const [imageErrors, setImageErrors] = useState({});

  // Handle image load success
  const handleImageLoad = (imageUrl) => {
    setLoadedImages(prev => ({ ...prev, [imageUrl]: true }));
  };

  // Handle image load error
  const handleImageError = (e, imageUrl) => {
    console.error('Image failed to load:', imageUrl);
    setImageErrors(prev => ({ ...prev, [imageUrl]: true }));
    if (onError) {
      onError(e);
    }
  };

  if (!images || images.length === 0) {
    return null;
  }

  const goToPrevious = () => {
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const currentImageUrl = images[currentIndex];
  const isLoaded = loadedImages[currentImageUrl];
  const hasError = imageErrors[currentImageUrl];

  return (
    <div className="notice-image-container">
      <div className="carousel-container" style={{ position: 'relative', minHeight: '200px' }}>
        {/* Loading spinner */}
        {!isLoaded && !hasError && (
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 10
          }}>
            <Spinner animation="border" size="sm" />
          </div>
        )}

        {/* Previous button */}
        {images.length > 1 && (
          <button 
            className="carousel-button prev" 
            onClick={goToPrevious}
            aria-label="Previous image"
            style={{ zIndex: 20 }}
          >
            &lt;
          </button>
        )}
        
        {/* Image */}
        <img 
          src={currentImageUrl}
          alt={`${title || 'Notice'} - Image ${currentIndex + 1}`}
          className="notice-image"
          onLoad={() => handleImageLoad(currentImageUrl)}
          onError={(e) => handleImageError(e, currentImageUrl)}
          loading="eager"
          style={{
            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out'
          }}
        />
        
        {/* Next button */}
        {images.length > 1 && (
          <button 
            className="carousel-button next" 
            onClick={goToNext}
            aria-label="Next image"
            style={{ zIndex: 20 }}
          >
            &gt;
          </button>
        )}
      </div>
      
      {/* Indicators */}
      {images.length > 1 && (
        <div className="carousel-indicators">
          {images.map((_, index) => (
            <button
              key={index}
              className={`carousel-indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Go to image ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;